/*
 * Copyright 2023, Corning Optical Communications
 * All Rights Reserved.
 */

import dayjs from "dayjs";
import { auditReportTypeValues, constStr, customTasks, rnLedActions } from "../../../globals/constants";
import { IAddScheduledTask, ITaskDetails, InitialStateTask } from "./types";
import { PayloadAction } from "@reduxjs/toolkit";

export const setScheduledTaskAction = (state: InitialStateTask | any, action: PayloadAction<IAddScheduledTask>) => {
  if (Object.keys(action.payload).length > 0) {
    state.scheduledtask = { ...state.scheduledtask, ...action.payload };
  } else {
    state.scheduledtask.domainKey = "Initial Domain";
    state.scheduledtask.deviceName = [];
    state.scheduledtask.siteGroupList = [];
    state.scheduledtask.regionList = [];
    state.scheduledtask.name = "";
    state.scheduledtask.description = "";
    state.scheduledtask.scheduleOnce = "0";
    state.scheduledtask.nextTime = dayjs().add(1, "minute").valueOf(); //start At
    state.scheduledtask.period = "0"; //Repeats
    state.scheduledtask.className = "";
    state.scheduledtask.encryptPasswords = false;
    state.scheduledtask.tasksMaxConcurrentDevices = "50"; //max Simultaneous Devices
    state.scheduledtask.setParameter = false;
    state.scheduledtask.parentTask = "None"; // Dependency task
    state.scheduledtask.taskProperties = {};
    state.activeTaskStep = 0;
    if (state.scheduledtask?.taskName.title === customTasks.reboot) {
      state.scheduledtask.radioUnitId = "";
      state.scheduledtask.radioNodeId = "";
      state.scheduledtask.sectorDeviceId = "";
      state.scheduledtask.cleanOption = "";
      state.scheduledtask.isSectorDeviceId = false;
      state.scheduledtask.isRadioUnitId = false;
      state.scheduledtask.isRadioNodsetSelectedeId = false;
      state.scheduledtask.isCleanOption = false;
      state.scheduledtask.taskName = { title: "", value: "" };
    } else if (
      state.scheduledtask?.taskName?.title === customTasks.softwareDownloadUpdate ||
      state.scheduleData?.taskName?.title === customTasks.softwareDownload
    ) {
      state.scheduledtask.protocol = "scp";
      state.scheduledtask.serverType = "Task Specific";
      state.scheduledtask.hostName = "";
      state.scheduledtask.port = 22;
      state.scheduledtask.fileName = "";
      state.scheduledtask.sshOperation = false;
      state.scheduledtask.sshKeyIndex = "";
      state.scheduledtask.softwareUpdateClean = "None";
      state.scheduledtask.username = "";
      state.scheduledtask.password = "";
    } else if (state.scheduledtask.taskName.title === customTasks.radioNodeReplace) {
      state.scheduledtask.oldRadioNodeId = null;
      state.scheduledtask.newRadioNodeId = null;
    } else if (state.scheduledtask.taskName.title === customTasks.lteCell || state.scheduledtask.taskName.title === customTasks.nrCell) {
      state.scheduledtask.idType = "";
      state.scheduledtask.cellAction = "";
      state.scheduledtask.cellIdValue = "";
      state.scheduledtask.zoneIdValue = "";
      state.scheduledtask.cellIdSet = false;
      state.scheduledtask.zoneIdSet = false;
      state.scheduledtask.allCell = true;
    } else if (state.scheduledtask.taskName.title === customTasks.snDbBackup || state.scheduledtask.taskName.title === customTasks.snDbRestore) {
      state.scheduledtask.fileName = "";
      state.scheduledtask.prefixFileName = "";
      state.scheduledtask.generateFileName = false;
      state.scheduledtask.includeDbLogging = false;
    } else if (state.scheduledtask.taskName.title === customTasks.radioNodeOperations) {
      state.scheduledtask.idType = "LED Operations";
      state.scheduledtask.actionName = rnLedActions[0];
      state.scheduledtask.radioNodeId = "";
      state.scheduledtask.followIMSI = "";
    } else if (state.scheduledtask.taskName.title === customTasks.exportSnDataModel) {
      state.scheduledtask.outputFormat = "";
      state.scheduledtask.outputDirectory = constStr.taskBackupLocation;
    } else if (state.scheduledtask.taskName.title === customTasks.setDebug) {
      state.scheduledtask.setDebug = "";
      state.scheduledtask.setDebugRows = [];
    } else if (state.scheduledtask.taskName.title === customTasks.lciSetPassword || state.scheduledtask.taskName.title === customTasks.setPassword) {
      state.scheduledtask.username = "field_recovery";
      state.scheduledtask.password = "";
      state.scheduledtask.newPassword = "";
    } else if (state.scheduledtask.taskName.title === customTasks.radiounitTroubleshooting) {
      state.scheduledtask.radiounitLogRequest = "RU_LOG_START";
      state.scheduledtask.radiounitId = "";
    } else if (state.scheduledtask.taskName.title === customTasks.lteRnLocation) {
      state.scheduledtask.isAll = false;
      state.scheduledtask.zoneIdValue = "";
      state.scheduledtask.radioNodeId = "";
      state.scheduledtask.lteRnLocationRequest = constStr.checkLocation;
    } else if (state.scheduledtask.taskName.title === customTasks.lteSelfConfig) {
      state.scheduledtask.lteSelfConfigType = constStr.neighborList;
      state.scheduledtask.txPowerType = "Max Power";
      state.scheduledtask.allString = "";
      state.scheduledtask.zoneIdValue = "";
      state.scheduledtask.neighborToCover = "";
      state.scheduledtask.maxSwing = "";
      state.scheduledtask.targetRSRP = "";
      state.scheduledtask.targetSIR = "";
      state.scheduledtask.nominalPLHigh = "";
      state.scheduledtask.nominalPLLow = "";
      state.scheduledtask.zoneRemValue = "";
    } else if (state.scheduledtask.taskName.title === customTasks.fileManagementCreate) {
      state.scheduledtask.nodeFileMgmt = [];
      state.nodeFileMgmtAllInString = "";
    } else if (state.scheduledtask.taskName.title === customTasks.testSnmpTrap) {
      state.scheduledtask.trapName = "EranNotifTest";
      state.scheduledtask.trapTarget = 0;
      state.scheduledtask.trapSeverity = "Clear";
    } else if (state.scheduledtask.taskName.title === customTasks.lteRemStart) {
      state.scheduledtask.zoneIdValue = "";
      state.scheduledtask.referenceSinglePowerEnabled = "false";
    } else if (state.scheduledtask.taskName.title === customTasks.auditReports) {
      state.scheduledtask.auditReportType = "None";
      state.scheduledtask.customReportInputMode = "TEMPLATE";
      state.scheduledtask.templateName = "";
      state.scheduledtask.manualAttributes = "";
      state.scheduledtask.reportFileName = "";
      state.scheduledtask.emailGroupName = "";
    } else if (state.scheduledtask.taskName.title === customTasks.customAuditReport) {
      state.scheduledtask.auditReportType = auditReportTypeValues.customAuditReport;
      state.scheduledtask.customReportInputMode = "TEMPLATE";
      state.scheduledtask.templateName = "";
      state.scheduledtask.manualAttributes = "";
      state.scheduledtask.nodeType = "ALL";
      state.scheduledtask.reportFileName = "";
      state.scheduledtask.emailGroupName = "";
    }
    state.scheduledtask.taskName = { title: "", value: "" };
  }
};

export const setActiveTaskStepAction = (state: InitialStateTask | any, action: PayloadAction<number>) => {
  state.activeTaskStep = action.payload;
};

export const setIsEditTaskAction = (state: InitialStateTask, action: PayloadAction<boolean>) => {
  state.isEditTask = action.payload;
};

export const setSelectedTaskAction = (state: InitialStateTask | any, action: PayloadAction<ITaskDetails>) => {
  state.selectedTask = { ...action.payload };
};

export const setSelectedTemplateAction = (state: InitialStateTask | any, action: PayloadAction<string>) => {
  state.selectedTemplate = action.payload;
};
